/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '../core/request';

export class AlertMessagesVService {

    /**
     * @param operatorId
     * @returns string OK
     * @throws ApiError
     */
    public static async alertMessagesVGetGlobalAlerts(
        operatorId?: string,
    ): Promise<Array<string>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/alert-messages/global`,
            query: {
                'operatorId': operatorId,
            },
        });
        return result.body;
    }

}